import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CardMaterial from '@material-ui/core/Card';

const useStyles = makeStyles({
  root: {
    backgroundColor: '#fff',
    padding: 10,
    borderRadius: 10,
  },
});

interface ICardProps {
  // eslint-disable-next-line react/require-default-props
  children?: JSX.Element | JSX.Element[] | null;
}

const Card: React.FC<ICardProps> = ( props ) => {
  const classes = useStyles();

  const { children } = props;

  return (
    <CardMaterial className={classes.root}>
      { children }
    </CardMaterial>
  );
};

export default Card;
